module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-08.7afb065a.svg";